import { Component } from '@angular/core';

@Component({
  selector: 'app-downarrow',
  templateUrl: './downarrow.component.html',
  styleUrls: ['./downarrow.component.scss'],
})
export class DownarrowComponent {

    static componentName = 'DownarrowComponent';

    scrollDown() {
        if (typeof window !== 'undefined') {
            this.smoothScroll();
        }
    }

    // Smooth scrolling without jQuery is complicated :)
    smoothScroll() {
        const startY = this.currentYPosition();
        const stopY = 100 * window.innerHeight / 100; // 100vh
        const distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY); return;
        }
        let speed = Math.round(distance / 50);
        if (speed >= 20) {
            speed = 20;
        }
        const step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
                leapY += step; if (leapY > stopY) {
                    leapY = stopY;
                }
                timer++;
            } return;
        }
        for (let i = startY; i > stopY; i -= step) {
            setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed);
            leapY -= step; if (leapY < stopY) {
                leapY = stopY;
            }
            timer++;
        }
    }

    currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) {
            return self.pageYOffset;
        }
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        }
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) {
            return document.body.scrollTop;
        } else {
            return 0;
        }
    }
}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/downarrow/downarrow.component.ts